export default {
      id: "burger-usage",
      viewBox: "0 0 15 17",
      url: "/" + "assets/sprite.svg#burger",
      toString: function () {
        return this.url;
      }
    }